export const isOnlyDigits = (value: string) => /^\d+$/.test(value)

export const isOnlyDigitsAndPoints = (value: string) => /\d\.*$/g.test(value)
